export default "__VITE_ASSET__DS0BtNj7__"